export const SZ_FORM_OWNER_ID = 1;
